import TableContainerReactTable from 'Components/Common/TableContainerReactTable';
import React, { useMemo } from 'react';
import { Row, Col, DropdownItem, ButtonGroup, UncontrolledDropdown, DropdownMenu, DropdownToggle } from 'reactstrap';

const StockMatrixTab: React.FC = () => {

  const columns = useMemo(() => [
    {header: 'Colour', accessorKey: 'colour', enableColumnFilter: false, cell: (cell: any) => (<div>{cell.getValue()}</div>) },
    {header: 'Size', accessorKey: 'size', enableColumnFilter: false, cell: (cell: any) => (<div>{cell.getValue()}</div>) },
  ], [])

  const data = useMemo(() => [
    { colour: 'Blue', size: '12' },
    { colour: 'Red', size: '14' },
    { colour: 'Yellow', size: '16' },
  ], [])

  return (
    <div className="stock-matrix-tab">
      <fieldset className="border rounded m-1 p-2 w-100">
        <Row className='justify-content-end'>
          <Col className='d-flex justify-content-end'>
            <div className='d-flex align-items-center'>
              <small className="text-muted me-2">Value</small>
              <ButtonGroup>
                <UncontrolledDropdown>
                  <DropdownToggle tag="button" className="btn btn-light btn-sm">
                    Select Value <i className="mdi mdi-chevron-down"></i>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>IN Wh</DropdownItem>
                    <DropdownItem>Available</DropdownItem>
                    <DropdownItem>On Order</DropdownItem>
                    <DropdownItem>On Hold</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </ButtonGroup>
            </div>

          </Col>

          <Col className='d-flex justify-content-end'>
            <div className='d-flex align-items-center'>
              <small className="text-muted me-2">Location</small>
              <ButtonGroup>
                <UncontrolledDropdown>
                  <DropdownToggle tag="button" className="btn btn-light btn-sm">
                    Select Location <i className="mdi mdi-chevron-down"></i>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>Main Warehouse</DropdownItem>
                    <DropdownItem>Warehouse 2</DropdownItem>
                    <DropdownItem>Warehouse 3</DropdownItem>
                    <DropdownItem>Warehouse 4</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </ButtonGroup>
            </div>
          </Col>
        </Row>
        <Row className="mt-1 mb-2">
          <div className='table-responsive w-80'>
            <TableContainerReactTable
              columns={columns}
              data={data}
              isGlobalFilter={false}
              customPageSize={5}
              divClass="mb-0"
              tableClass="table-centered align-middle table-nowrap mb-0"
              theadClass="table-light"
              thClass="px-3 py-2"
              verticalLines={true}
            />
          </div>
        </Row>
        <Row>
          <Col className='d-flex justify-content-start'>
            <div className='d-flex align-items-center'>
              <small className="text-muted me-2 text-nowrap">Total Quantity</small>
              <input type="text" className="form-control form-control-sm" />
            </div>
          </Col>
        </Row>
      </fieldset>
    </div>
  );
};

export default StockMatrixTab;
